import { createActionThunk } from 'redux-thunk-actions'
import { handleActions } from 'redux-actions'

import api from 'core/api'

const getType = type => `@parameters/${type}`

export const getParameters = createActionThunk(getType('FETCH'), api('/parameters'))

const initialState = { json: {} }

export default handleActions(
  {
    [getParameters.SUCCEEDED]: (state, action) => action.payload
  },
  initialState
)



// WEBPACK FOOTER //
// ./src/modules/parameters.js